/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCallDetailCustomerFromJSON, StreemApiCallDetailCustomerToJSON, StreemApiCallDetailItemFromJSON, StreemApiCallDetailItemToJSON, } from './';
export function StreemApiCallDetailFromJSON(json) {
    return StreemApiCallDetailFromJSONTyped(json, false);
}
export function StreemApiCallDetailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'callSourceSid': !exists(json, 'call_source_sid') ? undefined : json['call_source_sid'],
        'items': !exists(json, 'items') ? undefined : (json['items'].map(StreemApiCallDetailItemFromJSON)),
        'customer': !exists(json, 'customer') ? undefined : StreemApiCallDetailCustomerFromJSON(json['customer']),
        'callSourceCode': !exists(json, 'call_source_code') ? undefined : json['call_source_code'],
        'transferred': !exists(json, 'transferred') ? undefined : json['transferred'],
        'requeued': !exists(json, 'requeued') ? undefined : json['requeued'],
        'transferToGroupName': !exists(json, 'transfer_to_group_name') ? undefined : json['transfer_to_group_name'],
    };
}
export function StreemApiCallDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'call_source_sid': value.callSourceSid,
        'items': value.items === undefined ? undefined : (value.items.map(StreemApiCallDetailItemToJSON)),
        'customer': StreemApiCallDetailCustomerToJSON(value.customer),
        'call_source_code': value.callSourceCode,
        'transferred': value.transferred,
        'requeued': value.requeued,
        'transfer_to_group_name': value.transferToGroupName,
    };
}
//# sourceMappingURL=StreemApiCallDetail.js.map